import React from 'react';
import { Link } from 'react-router-dom';
import './Education.css';

const Education: React.FC = () => {
  return (
    <div className="education-page">
      <div className="container">
        <div className="page-title">
          <h1>Trading Education</h1>
          <p>Professional trading education for all levels of traders</p>
        </div>

        <section className="learning-levels">
          <h2>Choose Your Learning Path</h2>
          <div className="levels-grid">
            <div className="level-card beginner">
              <h3 style={{color: 'white'}}>Beginner</h3>
              <ul className="level-features">
                <li>Introduction to Financial Markets</li>
                <li>Understanding Trading Basics</li>
                <li>Technical Analysis Fundamentals</li>
                <li>Risk Management Principles</li>
              </ul>
              <Link to="/education/beginner" className="btn">Start Learning</Link>
            </div>

            <div className="level-card intermediate">
              <h3 style={{color: 'white'}}>Intermediate</h3>
              <ul className="level-features">
                <li>Advanced Chart Patterns</li>
                <li>Indicator Applications</li>
                <li>Trading Psychology</li>
                <li>Money Management</li>
              </ul>
              <Link to="/education/intermediate" className="btn">Start Learning</Link>
            </div>

            <div className="level-card advanced">
              <h3 style={{color: 'white'}}>Advanced</h3>
              <ul className="level-features">
                <li>Algorithmic Trading</li>
                <li>Quantitative Analysis</li>
                <li>Multi-Asset Strategies</li>
                <li>Performance Optimization</li>
              </ul>
              <Link to="/education/advanced" className="btn">Start Learning</Link>
            </div>
          </div>
        </section>
        
        <div className="education-grid">
          <div className="education-card">
            <h3>Forex Education</h3>
            <p>Learn about currency trading, technical analysis, and market dynamics</p>
            <Link to="/education/forex" className="btn">Start Learning</Link>
          </div>
          
          <div className="education-card">
            <h3>Commodity Education</h3>
            <p>Understand commodity markets, supply/demand, and price movements</p>
            <Link to="/education/commodity" className="btn">Start Learning</Link>
          </div>
          
          <div className="education-card">
            <h3>Indices Education</h3>
            <p>Learn to trade major global indices and understand market correlation</p>
            <Link to="/education/indices" className="btn">Start Learning</Link>
          </div>
          
          <div className="education-card">
            <h3>Stocks Education</h3>
            <p>Learn stock analysis, fundamental analysis, and portfolio management</p>
            <Link to="/education/stocks" className="btn">Start Learning</Link>
          </div>
          
          <div className="education-card">
            <h3>Crypto Currency Education</h3>
            <p>Understand cryptocurrency markets, blockchain technology, and digital assets</p>
            <Link to="/education/crypto" className="btn">Start Learning</Link>
          </div>
        </div>
        
        <div className="education-info">
          <h2>Professional Trading Education</h2>
          <p>Our comprehensive education program is designed for traders of all levels, from beginners to experienced professionals. We provide practical knowledge, real-world examples, and hands-on training to help you become a successful trader.</p>
          
          <div className="education-features">
            <div className="feature">
              <h3>Expert Instructors</h3>
              <p>Learn from professional traders with years of market experience</p>
            </div>
            <div className="feature">
              <h3>Practical Training</h3>
              <p>Real market scenarios and practical application of trading concepts</p>
            </div>
            <div className="feature">
              <h3>Ongoing Support</h3>
              <p>Continue learning with our community and ongoing resources</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Education;